export const THIS_WEEK = 'This week';
export const LAST_WEEK = 'Last week';
export const THIS_SCHOOL_YEAR = 'This school year';
export const CUSTOM_DATE = 'Custom date';
export const CUSTOM_DATE_TIME = 'Date and Time';
export const LIFETIME = 'Lifetime';

export const THIS_WEEK_OBJ = {
    label: THIS_WEEK,
    value: THIS_WEEK
};

export const LAST_WEEK_OBJ = {
    label: LAST_WEEK,
    value: LAST_WEEK
};
export const THIS_SCHOOL_YEAR_OBJ = {
    label: THIS_SCHOOL_YEAR,
    value: THIS_SCHOOL_YEAR
};
export const CUSTOM_DATE_OBJ = {
    label: CUSTOM_DATE,
    value: CUSTOM_DATE
};

export const CUSTOM_DATE_TIME_OBJ = {
    label: CUSTOM_DATE_TIME,
    value: CUSTOM_DATE_TIME
};

export const LIFETIME_OBJ = {
    label: LIFETIME,
    value: LIFETIME
};

export const DEFAULT_DATE_OPTIONS_OBJ = [
    THIS_WEEK_OBJ,
    LAST_WEEK_OBJ,
    THIS_SCHOOL_YEAR_OBJ,
    CUSTOM_DATE_OBJ
];

export const DEFAULT_DATE_OPTIONS = [
    THIS_WEEK,
    LAST_WEEK,
    THIS_SCHOOL_YEAR,
    CUSTOM_DATE
];
export const DATE_OPTIONS = [
    ...DEFAULT_DATE_OPTIONS,
    CUSTOM_DATE_TIME,
    LIFETIME
];



// WEBPACK FOOTER //
// ./components/date-picker/components/date-picker-trans/date-picker-constants.js